import { create } from 'zustand';

interface SeatState {
  sessionId: number | null;
  selectedSeatIds: number[];     // seats I currently hold for this session
  orderId: number | null;
  heldUntil: string | null;      // ISO
  setContext: (sessionId: number) => void;
  add: (seatId: number, orderId: number, heldUntil: string) => void;
  remove: (seatId: number) => void;
  reset: () => void;
}

export const useSeatStore = create<SeatState>((set) => ({
  sessionId: null,
  selectedSeatIds: [],
  orderId: null,
  heldUntil: null,
  setContext: (sessionId) =>
    set((s) => (s.sessionId === sessionId ? s : { sessionId, selectedSeatIds: [], orderId: null, heldUntil: null })),
  add: (seatId, orderId, heldUntil) =>
    set((s) => ({
      selectedSeatIds: s.selectedSeatIds.includes(seatId) ? s.selectedSeatIds : [...s.selectedSeatIds, seatId],
      orderId,
      heldUntil,
    })),
  remove: (seatId) =>
    set((s) => ({ selectedSeatIds: s.selectedSeatIds.filter((id) => id !== seatId) })),
  reset: () => set({ selectedSeatIds: [], orderId: null, heldUntil: null }),
}));
